export default "__VITE_ASSET__BjVE9JnO__"